import type { MockWorkout, MockWorkoutGroup } from './types';

const baseGroups: MockWorkoutGroup[] = [
    {
        id: 'grp-vel',
        name: 'Velocisti',
        variants: [
            {
                id: 'v-vel-1',
                label: 'Base',
                blocks: [
                    {
                        id: 'b1',
                        defaultReps: 1,
                        distance: 400,
                        style: 'MX',
                        intensity: 'A1',
                        sendoff: '',
                        equipment: []
                    },
                    {
                        id: 'b2',
                        defaultReps: 8,
                        distance: 50,
                        style: 'SL',
                        intensity: 'B2',
                        sendoff: '1:00',
                        equipment: ['pinne'],
                        pattern: 'manual'
                    },
                    {
                        id: 'b3',
                        defaultReps: 4,
                        distance: 100,
                        style: 'SL',
                        intensity: 'C1',
                        sendoff: '1:30',
                        pattern: 'progression'
                    },
                    { id: 'b4', defaultReps: 1, distance: 200, style: 'SL', intensity: 'A1', sendoff: '' }
                ]
            }
        ]
    },
    {
        id: 'grp-mezzo',
        name: 'Mezzofondisti',
        variants: [
            {
                id: 'v-mezzo-1',
                label: 'Base',
                blocks: [
                    { id: 'b1', defaultReps: 1, distance: 600, style: 'MX', intensity: 'A1', sendoff: '' },
                    {
                        id: 'b2',
                        defaultReps: 10,
                        distance: 100,
                        style: 'SL',
                        intensity: 'B1',
                        sendoff: '1:20',
                        pattern: 'uniform'
                    },
                    {
                        id: 'b3',
                        defaultReps: 3,
                        distance: 400,
                        style: 'SL',
                        intensity: 'B2',
                        sendoff: '5:30',
                        pattern: 'manual'
                    },
                    { id: 'b4', defaultReps: 1, distance: 400, style: 'SL', intensity: 'A1', sendoff: '' }
                ]
            }
        ]
    }
];

export const mockWorkouts: MockWorkout[] = [
    {
        id: 'wk-1',
        title: 'Tecnica + Soglia',
        date: '2026-04-21',
        coachId: 'user-coach-1',
        type: 'soglia',
        pool: '50',
        totalDistance: 3800,
        duration: 90,
        groups: baseGroups,
        status: 'assigned',
        assignedAthletes: [
            'athlete-self',
            'athlete-1',
            'athlete-2',
            'athlete-3',
            'athlete-4',
            'athlete-5',
            'athlete-6'
        ],
        feedbackCount: 3
    },
    {
        id: 'wk-2',
        title: 'Velocità 50/100',
        date: '2026-04-22',
        coachId: 'user-coach-1',
        type: 'velocita',
        pool: '25',
        totalDistance: 3200,
        duration: 75,
        groups: baseGroups,
        status: 'assigned',
        assignedAthletes: ['athlete-self', 'athlete-1', 'athlete-2', 'athlete-4', 'athlete-7', 'athlete-9'],
        feedbackCount: 0
    },
    {
        id: 'wk-3',
        title: 'Aerobico Lungo',
        date: '2026-04-19',
        coachId: 'user-coach-1',
        type: 'aerobico',
        pool: '50',
        totalDistance: 5200,
        duration: 110,
        groups: baseGroups,
        status: 'completed',
        assignedAthletes: [
            'athlete-self',
            'athlete-1',
            'athlete-2',
            'athlete-3',
            'athlete-4',
            'athlete-5',
            'athlete-6',
            'athlete-7'
        ],
        feedbackCount: 5,
        bestAthleteId: 'athlete-2'
    },
    ...Array.from({ length: 12 }, (_, i) => ({
        id: `wk-${i + 4}`,
        title: ['Tecnica Dorso', 'Forza Pinne', 'Test 400 MX', 'Recupero', 'Andatura Gara', 'Lattacido Corto'][i % 6],
        date: `2026-04-${String(10 - i).padStart(2, '0')}`,
        coachId: 'user-coach-1',
        type: (['tecnica', 'aerobico', 'soglia', 'velocita', 'gara'] as const)[i % 5],
        pool: (i % 2 === 0 ? '50' : '25') as '50' | '25',
        totalDistance: 3000 + i * 300,
        duration: 70 + i * 5,
        groups: baseGroups,
        status: 'completed' as const,
        assignedAthletes: [
            'athlete-self',
            'athlete-1',
            'athlete-2',
            'athlete-3',
            'athlete-4',
            'athlete-5',
            'athlete-6',
            'athlete-7',
            'athlete-8'
        ],
        feedbackCount: 3 + (i % 4),
        // Alcuni workout hanno già il "best": ci voto mock su 1 su 3
        bestAthleteId: i % 3 === 0 ? `athlete-${(i % 8) + 1}` : undefined
    }))
];
